import React from 'react';
import Logo from 'oldAssets/images/static_pages/smart_sales/shield.webp';
import styles from './InfoBox.module.scss';

const InfoBox = ({ title, text, label }) => {
  return (
    <div className={ styles.InfoBox }>
      <img src={ Logo } width="64"
        height="73"
      />
      <div className={ styles.content }>
        <h5>{ title }</h5>
        { text && text.map(item => <p key={ item }>{ item }</p>) }
      </div>
      <div className={ styles.infoFlag }>
        <div className={ styles.flag }></div>
        <span className={ styles.label }>{ label }</span>
      </div>
    </div>
  );
};
 
export default InfoBox;